import { Link } from 'react-router-dom';
import { DashboardSidebar } from '@/layouts/dashboard';
import React from 'react';
import { FiChevronLeft } from 'react-icons/fi';
import { StepperWrapper } from '@/components/custom/stepper';
import { ButtonBack, ButtonBackContent } from '@/components/ui/button';
import { IconWrapper } from '@/components/custom/icon';
import { FilterTitle } from '@/components/custom/filter';

function MockQuestionBookSidebar(props) {
  const { steps, currentStep } = props;

  return (
    <DashboardSidebar
      hasBrand={false}
      viewMode="create"
    >
      <ButtonBack asChild>
        <Link to="/avaliacoes/simulados">
          <IconWrapper>
            <FiChevronLeft />
          </IconWrapper>
          <ButtonBackContent>
            <FilterTitle>Simulados</FilterTitle>
          </ButtonBackContent>
        </Link>
      </ButtonBack>

      <StepperWrapper
        steps={steps}
        currentStep={currentStep - 1}
      />
    </DashboardSidebar>
  );
}

export default MockQuestionBookSidebar;
